import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import CheckoutStepper from '../../components/CheckoutStepper/CheckoutStepper.component'
import { CheckoutContext } from '../../context/CheckoutContext/checkout.context'
import { homeRoute } from '../Home/route.const'
import CustomerStep from './components/CustomerStep/CustomerStep.component'
import PaymentStep from './components/PaymentStep/PaymentStep.component'
import VehicleStep from './components/VehicleStep/VehicleStep.component'
import { Container, ContentContainer, InnerContainer, StickySection } from './Checkout.style'
import ConfirmationStep from './components/ConfirmationStep/ConfirmationStep.component'
import OrderDetails from './components/OrderDetails/OrderDetails.component'
import StickyMobileSection from '@components/StickyMobileSection/StickyMobileSection.component'

const Checkout = () => {
    const location = useLocation()

    const [checkoutStep, setCheckoutStep] = useState(1)
    const { checkout } = useContext(CheckoutContext)

    const bottomRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const step = urlParams.get('step')
        if (step === 'vehicle') {
            setCheckoutStep(1)
        } else if (step === 'contact') {
            setCheckoutStep(2)
        } else if (step === 'confirmation') {
            setCheckoutStep(3)
        } else if (step === 'payment') {
            setCheckoutStep(4)
        } else {
            setCheckoutStep(1)
        }
    }, [location.search])

    // if no checkout data - redirect to home page
    if (checkout === null) {
        return <Redirect push to={homeRoute()} />
    }
    return (
        <Container>
            <InnerContainer>
                <CheckoutStepper step={checkoutStep} noOfSteps={4} />

                {/* steps content */}
                <ContentContainer>
                    {checkoutStep === 1 && <VehicleStep bottomRef={bottomRef} />}
                    {checkoutStep === 2 && <CustomerStep bottomRef={bottomRef} />}
                    {checkoutStep === 3 && <ConfirmationStep bottomRef={bottomRef} />}
                    {checkoutStep === 4 && <PaymentStep />}
                </ContentContainer>

                {/* booking details content */}
                {checkoutStep !== 3 && <OrderDetails />}
            </InnerContainer>

            {/* little hacky, but okay for now */}
            <StickyMobileSection height={checkoutStep === 3 ? '14rem' : checkoutStep === 4 ? 'unset' : undefined}>
                <StickySection ref={bottomRef} $hide={checkoutStep === 4} />
            </StickyMobileSection>
        </Container>
    )
}

export default Checkout
